import React from 'react'
import PropTypes from 'prop-types'
import '../assets/css/components/legend-pills.css'

const LegendPills = ({ color, linkCount })=>
  <div className='legend-pills-container'>
    {Array.from(Array(linkCount)).map((x,i) =>
      <div key={i} className='legend-pill' style={{background: color}}/>
    )}
  </div>

export default LegendPills

LegendPills.propTypes = {
  color: PropTypes.string,
  linkCount: PropTypes.number
}
